// Mirror of backend SOUND_SIGNALS + MOVEMENT_SIGNALS used to render team avatars
// when group.avatar_id is a signal id (auto-assigned during create_groups).
// Keep this in sync with /app/backend/server.py SOUND_SIGNALS / MOVEMENT_SIGNALS.

export const SIGNAL_AVATARS = {
  // Sound signals (animals)
  kitten:   { emoji: "🐱", name: "Kitten" },
  owl:      { emoji: "🦉", name: "Owl" },
  drum:     { emoji: "🥁", name: "Drum" },
  wolf:     { emoji: "🐺", name: "Wolf" },
  dolphin:  { emoji: "🐬", name: "Dolphin" },
  elephant: { emoji: "🐘", name: "Elephant" },
  rooster:  { emoji: "🐓", name: "Rooster" },
  monkey:   { emoji: "🐒", name: "Monkey" },
  lion:     { emoji: "🦁", name: "Lion" },
  duck:     { emoji: "🦆", name: "Duck" },
  frog:     { emoji: "🐸", name: "Frog" },
  snake:    { emoji: "🐍", name: "Snake" },
  bee:      { emoji: "🐝", name: "Bee" },
  horse:    { emoji: "🐴", name: "Horse" },
  pig:      { emoji: "🐷", name: "Pig" },
  cow:      { emoji: "🐄", name: "Cow" },
  parrot:   { emoji: "🦜", name: "Parrot" },
  whale:    { emoji: "🐋", name: "Whale" },
  cricket:  { emoji: "🦗", name: "Cricket" },
  bear:     { emoji: "🐻", name: "Bear" },
  seagull:  { emoji: "🦤", name: "Seagull" },
  donkey:   { emoji: "🫏", name: "Donkey" },
  penguin:  { emoji: "🐧", name: "Penguin" },
  turkey:   { emoji: "🦃", name: "Turkey" },
  seal:     { emoji: "🦭", name: "Seal" },
  goat:     { emoji: "🐐", name: "Goat" },
  peacock:  { emoji: "🦚", name: "Peacock" },
  tiger:    { emoji: "🐅", name: "Tiger" },
  crow:     { emoji: "🐦‍⬛", name: "Crow" },
  gecko:    { emoji: "🦎", name: "Gecko" },
  sheep:    { emoji: "🐑", name: "Sheep" },
  gorilla:  { emoji: "🦍", name: "Gorilla" },
  cat:      { emoji: "😺", name: "Cat" },
  hyena:    { emoji: "🦊", name: "Hyena" },
  eagle:    { emoji: "🦅", name: "Eagle" },
  // Movement signals
  wings:    { emoji: "🕊️", name: "Wings" },
  rowing:   { emoji: "🚣",  name: "Rowing" },
  statue:   { emoji: "🗽", name: "Statue" },
  wave:     { emoji: "🌊", name: "Wave" },
  jumping:  { emoji: "⭐", name: "Jumping" },
  spin:     { emoji: "🔄", name: "Spin" },
  robot:    { emoji: "🤖", name: "Robot" },
  squat:    { emoji: "🏋️", name: "Squat" },
  tiptoe:   { emoji: "🩰", name: "Tiptoe" },
  zombie:   { emoji: "🧟", name: "Zombie" },
  swim:     { emoji: "🏊", name: "Swim" },
  moonwalk: { emoji: "🌙", name: "Moonwalk" },
  karate:   { emoji: "🥋", name: "Karate" },
  stretch:  { emoji: "🧘", name: "Stretch" },
  march:    { emoji: "🎖️", name: "March" },
  clap:     { emoji: "👏", name: "Clap" },
  twist:    { emoji: "💃", name: "Twist" },
  shake:    { emoji: "🫨", name: "Shake" },
  lunge:    { emoji: "🦵", name: "Lunge" },
  crab:     { emoji: "🦀", name: "Crab" },
  hop:      { emoji: "🐇", name: "Hop" },
  ski:      { emoji: "⛷️", name: "Ski" },
  box:      { emoji: "🥊", name: "Box" },
  salsa:    { emoji: "🎶", name: "Salsa" },
  balance:  { emoji: "🦩", name: "Flamingo" },
  climb:    { emoji: "🧗", name: "Climb" },
  disco:    { emoji: "🪩", name: "Disco" },
  windmill: { emoji: "🌀", name: "Windmill" },
  ninja:    { emoji: "🥷", name: "Ninja" },
  sumo:     { emoji: "🏯", name: "Sumo" },
  airplane: { emoji: "✈️", name: "Airplane" },
  conductor:{ emoji: "🎵", name: "Conductor" },
  penguin_walk: { emoji: "🐧", name: "Penguin Walk" },
  hula:     { emoji: "⭕", name: "Hula" },
  archer:   { emoji: "🏹", name: "Archer" },
};

export const lookupSignalAvatar = (avatarId) => SIGNAL_AVATARS[avatarId] || null;
